export function replaceStrFilter () {
	return function (str, replace = '', replaceWith = '') {
		return str.replaceAll(replace, replaceWith);
	};
}
